import { Site } from '@envato/foundation-types'
import * as React from 'react'
import { connect, Dispatch } from 'react-redux'

import { openModal } from '../../common/actions/layout'
import { addBookmark, deleteBookmark } from '../../common/actions/user/bookmark'
import { createFavoriteCollection } from '../../common/actions/user/collection'
import { setUserVideoPlayerStatus } from '../../common/actions/user/preference'
import { IRootState } from '../../common/reducers'
import { hasFeature } from '../../common/utils/features'

import {
  getUserCartItems,
  getUserCollections,
  getUserFavoriteCollectionID
} from '../../common/selectors/user'
import { IItem } from '../../typings/searchResults'

interface IOwnProps {
  location: any // TODO: REMOVE THIS WHEN LOCATION IS NOT ADDING QUERY
  matches: IItem[]
  isSqueezed?: boolean
  viewType?: string
}

interface IStateProps {
  currentSite: Site
  collections: any
  cartItems: any
  favoriteCollectionID: any
  token: string
  preferences: any
  isSqueezed: boolean
  viewType: string
}

interface IDispatchProps {
  deleteBookmark: (
    collectionID: any,
    itemID: any,
    id: any,
    isFavouriteCollection: any
  ) => any
  addBookmark: (
    collectionId: any,
    itemId: any,
    isFavouriteCollection: any
  ) => any
  openModal: (data: any) => any
  createFavoriteCollection: () => any
  muteVideo: () => any
}

const mapStateToProps = (
  state: IRootState,
  ownProps: IOwnProps
): IStateProps => {
  const {
    common: { currentSite },
    user: { token, preferences },
    layout: { isSidebarOpen },
    experiments
  } = state

  let nextViewType = ownProps.viewType || preferences.searchResultsViewType
  if (
    hasFeature(
      'removeLayoutSwitcher',
      currentSite,
      ownProps.location,
      experiments
    )
  ) {
    nextViewType = 'grid'
  }

  return {
    currentSite,
    collections: getUserCollections(state),
    cartItems: getUserCartItems(state),
    favoriteCollectionID: getUserFavoriteCollectionID(state),
    token,
    preferences,
    isSqueezed: ownProps.isSqueezed || isSidebarOpen,
    viewType: nextViewType
  }
}

const mapDispatchToProps = (
  dispatch: Dispatch<IRootState>,
  ownProps: IOwnProps
): IDispatchProps => {
  return {
    deleteBookmark: (collectionID, itemID, id, isFavouriteCollection) =>
      dispatch(deleteBookmark(
        collectionID,
        itemID,
        id,
        isFavouriteCollection
      ) as any),
    addBookmark: (collectionId, itemId, isFavouriteCollection) =>
      dispatch(addBookmark(collectionId, itemId, isFavouriteCollection) as any),
    openModal: data => dispatch(openModal(data)),
    createFavoriteCollection: () => dispatch(createFavoriteCollection()),
    muteVideo: () => dispatch(setUserVideoPlayerStatus(true))
  }
}

export type Props = IOwnProps & IDispatchProps & IStateProps

const createSearchResultBodyContainer = (
  component: React.ComponentType<Props>
) =>
  connect<IStateProps, IDispatchProps, IOwnProps, IRootState>(
    mapStateToProps,
    mapDispatchToProps
  )(component)

export default createSearchResultBodyContainer
